import React from 'react';
import ReactMarkdown from 'react-markdown';

import Article from './Article';

const components = {
  p: Article.P,
  h2: Article.Header,
  img: ({ alt, src }: { alt?: string; src?: string }) => (
    <Article.Image src={src!} alt={alt ?? ''} />
  ),
  a: ({ href, children }: { href?: string; children?: React.ReactNode }) => (
    <a href={href} target="_blank" rel="noreferrer">{children}</a>
  ),
};

export default function MarkdownBody({ children }: { children: string }) {
  return <ReactMarkdown components={components}>{children}</ReactMarkdown>;
}
